export default __webpack_public_path__ + "static/jobbox-2-c-384b512e5b94874903c0502e6af726a4.webp";